module.exports = __webpack_public_path__ + "index/img/vip-bg.915ec892.png";